const configs = {
  development: {
    baseURL: '',
    business: 'patientRecords',
    aegisKey: 'ZEaV8fva6mmD9xQDke',
  },
  production: {
    baseURL: '',
    business: 'patientRecords',
    aegisKey: 'mZ90nILWe8nbvb09x6',
  },
};
const env = process.env.NODE_ENV;
console.log('VUE_APP_ENV', process.env.VUE_APP_ENV);
console.log('NODE_ENV', process.env.NODE_ENV);
const config = configs[env];
export default config;
